<template>
    <div class="cart-page__body col-9 col-md-12">
        <div class="step-block">

            <steps-panel></steps-panel>

            <div class="step-block__head">
                <div class="step-block__title">Выберете способ оплаты</div>
            </div>
            <div class="step-block__row row">
                <div class="step-block__input-row col-12 radiobox-list radiobox-list--lg">

                    <div class="checkbox checkbox--sm" v-for="paysystem in availablePaySystems" :key="paysystem.ID">
                        <input type="radio" name="payment" :id="'payment-' + paysystem.ID" :value="paysystem.ID" v-model="model.paysystemId">
                        <label :for="'payment-' + paysystem.ID">{{ paysystem.NAME }}</label>
                    </div>

                </div>
            </div>
            
            <div class="step-block__buttons">
                <a @click.prevent="nextStep" href="#" class="btn btn--black btn--next btn--md">
                    <span>Далее</span>
                    <svg class="icon btn__icon">
                        <use xlink:href="/local/templates/reloft2020/asset/images/sprite.svg#btn-arrow"></use>
                    </svg>
                </a>
                <div class="input-row__error" v-for="(error, fieldName) in errors" :key="fieldName">{{ error }}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import StepsPanel from "@/components/Checkout/StepsPanel";
    import {mapActions, mapState} from 'vuex';

    export default {
        name: 'StepPayment',
        components: {
            StepsPanel,
        },
        watch: {
            'model.paysystemId': function () {
                this.loadOrderSummary(this.model);
            },
        },
        computed: {
            ...mapState('StoreCheckout', ['model', 'orderSummary', 'errors']),
            availablePaySystems: function () {
                return this.model.deliveryId && this.orderSummary.availablePaySystems ? this.orderSummary.availablePaySystems : [];
            }
        },
        methods: {
            ...mapActions('StoreCheckout', ['loadOrderSummary', 'nextStep'])
        },
    }
</script>